import Image from 'next/image';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { NON_RETURNABLE_ICON } from '@common/Utility/constants';
import { IC_NOREFUND_WHITE, IC_REFUND_WHITE, IC_RIGHT_ARROW_WHITE, IC_REFUND_GREEN, IC_GREEN_ARROW_RIGHT, IC_NON_RETURNABLE_INFO_ICON, IC_CART_GREEN, IC_LEFT_PAGINATION_ARROW_GREEN } from '@common/Assets/images';
import CustomModal from '@common/Component/Modal/Modal';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { checkIfCurrentLangIsArabic, getAppConfigDataByLang } from '@common/Utility/common-utils';
import { isRTL, useTranslation } from '@common/i18n';
import { getLangCodeFromUrl } from '../../../../i18n';

const ReturnableRibbon = (props) => {
  const [currentLang, setCurrentLanguage] = React.useState('');
  const generateURL = useNavigationURL();
  const t = useTranslation();

  const [infoModalData, setInfoModalData] = React.useState({ visible: false });
  const appConfig = useSelector((state) => state?.astercore?.AppConfig?.data?.data);

  React.useEffect(() => {
    if(window !== 'undefined'){
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);

  const showReturnableRibbon = () => {
    if (props?.customAttribute?.is_returnable === '1' && props?.customAttribute?.is_cancelable === '1') {
      const popupContent = getAppConfigDataByLang(appConfig, 'easy_refund_and_cancellation_content', currentLang );
      return (
        <div
          className="btnRefund"
          onClick={() => {
            setInfoModalData({
              visible: true,
              data: {
                title: t('ProductDetail.easyRefundAndCancellation'),
                description: popupContent,
                cta: '/faq/returns&refunds',
              },
            });
          }}
        >
          <div className="ic">
            <Image src={IC_REFUND_GREEN} width="32px" height="32px" alt="refund icon" />
          </div>
          <div className="text">{t('ProductDetail.easyRefundAndCancellation')}</div>
          <div className="arrow">
            {typeof window !== 'undefined' && checkIfCurrentLangIsArabic() ? <Image src={IC_LEFT_PAGINATION_ARROW_GREEN} width="24px" height="24px" alt=" right arrow" /> : <Image src={IC_GREEN_ARROW_RIGHT} width="24px" height="24px" alt=" right arrow" />}
          </div>
        </div>
      );
    }
  };

  const showCancelableRibbon = () => {
    if (props?.customAttribute?.is_returnable === '0') {
      const popupContent = getAppConfigDataByLang(appConfig, 'no_returnable_content', currentLang );
      return (
        <div
          className="btnRefund notRefundable"
          onClick={() => {
            setInfoModalData({
              visible: true,
              data: {
                title: 'Not Returnable Item',
                description: popupContent,
                cta: '/faq/returns&refunds',
              },
            });
          }}
        >
          <div className="text">{NON_RETURNABLE_ICON}</div>
          <div className="arrow">
            <Image src={IC_NON_RETURNABLE_INFO_ICON} width="24px" height="24px" alt="non returnable icon" />
          </div>
        </div>
      );
    }
  };

  return (
    <>
      {showReturnableRibbon()}
      {showCancelableRibbon()}
      {infoModalData?.visible === true && infoModalData?.data && (
        <CustomModal
          footerBtnFullWidth={true}
          modalTitle={infoModalData?.data?.title}
          titleLeftAligned={currentLang && !isRTL(currentLang) }
          titleRightAligned={currentLang && isRTL(currentLang) }
          size="lg"
          closeButton
          contentMaxHeight="400px"
          crossPressed={() => {
            setInfoModalData({ visible: false, data: null });
          }}
          noFooter
          customClass={'title-align-left modal_pdpAdvtBox'}
        >
          {infoModalData?.data?.description}
          {infoModalData?.data?.cta && infoModalData?.data?.cta !== '' && (
            <div>
              <a target="_blank" rel="noreferrer" href={generateURL(infoModalData?.data?.cta)}>
                {t('ProductDetail.readmore')}
              </a>
            </div>
          )}
        </CustomModal>
      )}
    </>
  );
};

ReturnableRibbon.propTypes = {
  detailsData: PropTypes.any,
  customAttribute: PropTypes.any,
};
export default ReturnableRibbon;
